import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import {
  BarChart3,
  Calendar,
  Plane,
  Scale,
  Settings,
  Users,
  Wallet,
} from 'lucide-react';

import { cn } from '../../lib/utils';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '../ui/sidebar';

import { AccountsList } from './AccountsList';
import { BudgetSwitcher } from './BudgetSwitcher';

const navItems = [
  { titleKey: 'Budget', icon: Wallet, to: '/budget' },
  { titleKey: 'Reports', icon: BarChart3, to: '/reports' },
  { titleKey: 'Schedules', icon: Calendar, to: '/schedules' },
  { titleKey: 'Travel', icon: Plane, to: '/travel' },
];

const moreItems = [
  { titleKey: 'Payees', icon: Users, to: '/payees' },
  { titleKey: 'Rules', icon: Scale, to: '/rules' },
  { titleKey: 'Settings', icon: Settings, to: '/settings' },
];

export function AppSidebar() {
  const { t } = useTranslation();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <BudgetSwitcher />
      </SidebarHeader>

      <SidebarContent>
        {/* Primary navigation */}
        <SidebarGroup>
          <SidebarGroupLabel>{t('Navigation')}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map(item => (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton asChild tooltip={t(item.titleKey)}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        cn(isActive && 'bg-sidebar-accent font-medium text-sidebar-accent-foreground')
                      }
                    >
                      <item.icon />
                      <span>{t(item.titleKey)}</span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        {/* More section */}
        <SidebarGroup>
          <SidebarGroupLabel>{t('More')}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {moreItems.map(item => (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton asChild tooltip={t(item.titleKey)}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        cn(isActive && 'bg-sidebar-accent font-medium text-sidebar-accent-foreground')
                      }
                    >
                      <item.icon />
                      <span>{t(item.titleKey)}</span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        {/* Accounts */}
        <AccountsList />
      </SidebarContent>

      <SidebarFooter />

      <SidebarRail />
    </Sidebar>
  );
}
